import React, { useRef, useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const toolbarOptions = [
  [{ header: [1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic', 'underline', 'strike'], // Formatting
  [{ list: 'ordered' }, { list: 'bullet' }], // Lists
  ['link', 'image'], // Links and images
  [{ align: [] }], // Alignment
  [{ color: [] }, { background: [] }], // Colors
  ['clean'], // Clear formatting

];

export function RichTextEditor({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const quillRef = useRef<ReactQuill | null>(null);
  const [isSourceMode, setIsSourceMode] = useState(false); // Toggle state

  useEffect(() => {
    const quillInstance = quillRef.current?.getEditor();

    if (quillInstance) {
      const toolbar = quillInstance.getModule('toolbar');
      toolbar.addHandler('image', handleImageUpload);
    }
  }, []);

  const handleImageUpload = () => {
    const quill = quillRef.current?.getEditor();
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files ? input.files[0] : null;
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('diskPrefix', 'EditorUploads');
        formData.append('disk', 'public');
        try {
          const response = await fetch('/api/v1/file-entries', {
            method: 'POST',
            body: formData,
          });
          const data = await response.json();
          const range = quill?.getSelection();
          if (range) {
            quill?.insertEmbed(range.index, 'image', data.fileEntry.url);
          }
        } catch (error) {
          console.error('Image upload failed:', error);
        }
      }
    };
  };

  const modules = {
    toolbar: toolbarOptions,
  };

  return (
    <div>
      {/* Toggle Button for Source Code Mode */}
      <button
        onClick={() => setIsSourceMode(!isSourceMode)}
        type="button"
        style={{
          marginBottom: '10px',
          padding: '8px 15px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        {isSourceMode ? 'Switch to Editor' : 'View Source Code'}
      </button>

      {isSourceMode ? (
        // Raw HTML Editing Mode
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{
            width: '100%',
            height: '300px',
            fontFamily: 'monospace',
            border: '1px solid #ccc',
            padding: '10px',
          }}
        />
      ) : (
        // Quill Editor Mode
        <ReactQuill
          ref={quillRef}
          value={value}
          onChange={onChange}
          modules={modules}
          formats={[
            'header',
            'bold',
            'italic',
            'underline',
            'strike',
            'blockquote',
            'list',
            'bullet',
            'link',
            'image',
            'align',
            'color',
            'background',
          ]}
        />
      )}
    </div>
  );
}
